import { useTranslation } from 'react-i18next';

import type { PublishedTermSummary } from '@/api/adapters/terms-policies';

import { TermsRow } from './TermsRow';

interface TermsListSectionProps {
  terms: PublishedTermSummary[];
  agreedOptional: Set<number>;
  onAgree: (typeId: number) => void;
}

export function TermsListSection({
  terms,
  agreedOptional,
  onAgree,
}: TermsListSectionProps) {
  const { t } = useTranslation('termsPolicies');

  return (
    <div className="settings-section">
      <h3>{t('sectionTitle')}</h3>
      {terms.map((term) => (
        <TermsRow
          key={term.typeId}
          term={term}
          agreed={agreedOptional.has(term.typeId)}
          onAgree={onAgree}
        />
      ))}
    </div>
  );
}
